import { render, staticRenderFns } from "./CadastrarRasgadinhas.vue?vue&type=template&id=1caac540&"
import script from "./CadastrarRasgadinhas.vue?vue&type=script&lang=js&"
export * from "./CadastrarRasgadinhas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports